import { useEffect } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useQueryUserId } from './memberHook';
import { replace, push, useRouteMatch } from '../../app/route';
import {
  getMemberListUrl,
  getMemberDetailUrl,
  UpdateMemberActionResponse,
  CreateMemberActionResponse,
} from './memberSlice';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import { MemberCreateForm } from './MemberCreateForm';
import { MemberEditForm } from './MemberEditForm';
import { MemberView } from './MemberView';

type PathParams = {
  mode: 'view'|'edit'|'create';
  tenant_id: string;
};

export function MemberPage() {
  const dispatch = useAppDispatch();
  const match = useRouteMatch<PathParams>();
  const { mode } = match.params;
  const user_id = useQueryUserId();
  const tenant_id = useAppSelector(selectCurrentTenantId);

  useEffect(() => {
    if (['view', 'edit'].includes(mode) && !user_id) {
      dispatch(replace(getMemberListUrl(tenant_id)));
    }
  }, [dispatch, user_id, mode, tenant_id]);
  useEffect(() => {
    if (tenant_id !== match.params.tenant_id) {
      dispatch(push(getMemberListUrl(tenant_id)));
    }
  }, [tenant_id, dispatch, match.params.tenant_id]);

  const handleCreateCallback = (result: CreateMemberActionResponse) => {
    dispatch(push(getMemberDetailUrl(tenant_id, result.id, 'view')));
  };
  const handleUpdateCallback = (result: UpdateMemberActionResponse) => {
    dispatch(push(getMemberDetailUrl(tenant_id, user_id, 'view')));
  };
  const handleDismissCallback = (error?: SerializedError) => {
    if (error) {
      dispatch(push(getMemberListUrl(tenant_id)));
    } else if (mode === 'create') {
      dispatch(push(getMemberListUrl(tenant_id)));
    } else if (mode === 'edit' || mode === 'view') {
      dispatch(push(getMemberDetailUrl(tenant_id, user_id, 'view')));
    }
  };
  const handleGoBack = () => {
    dispatch(push(getMemberListUrl(tenant_id)));
  };
  const handleEdit = () => {
    dispatch(push(getMemberDetailUrl(tenant_id, user_id, 'edit')));
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        { mode === 'create' && <h1>Create Member</h1> }
        { mode === 'edit' && <h1>Edit Member</h1> }
        { mode === 'view' && <h1>View Member</h1> }
        { mode === 'view' && 
          <div className="btn-group">
            <button className="btn btn-outline-primary my-2" onClick={handleGoBack}>
              GoBack
            </button>
            <button className="btn btn-outline-primary my-2" onClick={handleEdit}>
              Edit
            </button>
          </div>
        }
      </div>
      { mode === 'create' && 
        <MemberCreateForm
          tenant_id={tenant_id}
          successCallback={handleCreateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'edit' && 
        <MemberEditForm
          tenant_id={tenant_id}
          user_id={user_id}
          successCallback={handleUpdateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'view' &&
        <MemberView
          tenant_id={tenant_id}
          user_id={user_id}
          closeCallback={handleDismissCallback}
        />
      }
    </div>
  );
}
